import type { JSX } from 'react'
import { cn } from '@/lib/cn'

/**
 * Статусная точка. Живёт отдельным примитивом, потому что встречается в шести
 * местах и должна выглядеть одинаково.
 *
 * `pulse` — расходящееся кольцо вокруг точки: это про ПРОЦЕСС (подключаемся,
 * ждём переподключения), а не про украшение. У завершённых состояний пульса
 * нет: постоянно мигающий интерфейс утомляет при длительном наблюдении.
 *
 * Точка сама по себе смысл не несёт — рядом всегда стоит текст (правило
 * «цвет не единственный носитель смысла»).
 */
export type StatusTone = 'live' | 'warn' | 'busy' | 'hold' | 'idle' | 'fail'

const FILL: Record<StatusTone, string> = {
  live: 'bg-live',
  warn: 'bg-warn',
  busy: 'bg-busy',
  hold: 'bg-hold',
  idle: 'bg-idle',
  fail: 'bg-fail'
}

export function StatusDot({
  tone,
  pulse = false,
  className
}: {
  tone: StatusTone
  pulse?: boolean
  className?: string
}): JSX.Element {
  return (
    <span aria-hidden className={cn('relative flex size-2 shrink-0', className)}>
      {pulse ? (
        <span className={cn('anim-ping absolute inset-0 rounded-pill', FILL[tone])} />
      ) : null}
      <span className={cn('relative size-2 rounded-pill', FILL[tone])} />
    </span>
  )
}
